export const convertFirstLetterToUppercase = (string) =>
  string.charAt(0).toUpperCase() + string.slice(1);
